export const getCommentsAndReplies = ({
  commentAndRepliesReducer: { comments_and_replies = [] } = {},
}) => comments_and_replies;
export const getCommentsAndRepliesFilters = ({
  commentAndRepliesReducer: { filter = {} } = {},
}) => filter;
export const getCount = ({ commentAndRepliesReducer: { count = 0 } = {} }) =>
  count;
